import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiMail, FiMapPin, FiPhone } from "react-icons/fi";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { EMAIL, PHONE, PHONE_LABEL, whatsappLink } from "../../contact";
import "./Footer.css";

const NAV_LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/about", label: "À propos" },
  { to: "/catalogue", label: "Catalogue" },
  { to: "/contact", label: "Contact" },
  { to: "/FAQ", label: "FAQ" },
];

const SOCIALS = [
  { href: "https://web.facebook.com/aziz.assad.969", label: "Facebook", Icon: FaFacebookF },
  { href: "https://www.linkedin.com/in/aziz-assad-ba737052/", label: "LinkedIn", Icon: FaLinkedinIn },
  { href: "https://www.instagram.com/assad_inox/", label: "Instagram", Icon: FaInstagram },
  { href: whatsappLink("Bonjour Cristal Inox,"), label: "WhatsApp", Icon: FaWhatsapp },
];

function Footer() {
  return (
    <footer className="ft">
      <div className="ft-cta">
        <div>
          <h2>Prêt à lancer votre projet en inox ?</h2>
          <p>Devis gratuit et conseils personnalisés.</p>
        </div>
        <Link to="/contact" className="ft-cta__btn">
          Demander un devis <FiArrowRight />
        </Link>
      </div>

      <div className="ft-grid">
        <div className="ft-brand">
          <Link to="/" className="ft-logo" aria-label="Cristal Inox, accueil">
            <span className="ft-logo__name">Cristal Inox</span>
            <span className="ft-logo__tag">Chaudronnerie inox</span>
          </Link>
          <p>
            Passionnés par l'excellence de la chaudronnerie en acier inoxydable.
            Des solutions sur mesure pour la décoration, le médical et la
            tuyauterie industrielle.
          </p>
        </div>

        <nav className="ft-col" aria-label="Navigation du pied de page">
          <h3>Navigation</h3>
          <ul>
            {NAV_LINKS.map(({ to, label }) => (
              <li key={to}>
                <Link to={to}>{label}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="ft-col">
          <h3>Contact</h3>
          <ul>
            <li>
              <a href={`tel:${PHONE}`}>
                <FiPhone /> {PHONE_LABEL}
              </a>
            </li>
            <li>
              <a href={`mailto:${EMAIL}`}>
                <FiMail /> {EMAIL}
              </a>
            </li>
            <li>
              <span>
                <FiMapPin /> Tit Mellil, Casablanca, Maroc
              </span>
            </li>
          </ul>
        </div>

        <div className="ft-col">
          <h3>Suivez-nous</h3>
          <ul className="ft-social">
            {SOCIALS.map(({ href, label, Icon }) => (
              <li key={label}>
                <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
                  <Icon />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <p className="ft-bottom">
        &copy; {new Date().getFullYear()} Cristal Inox. Tous droits réservés.
      </p>
    </footer>
  );
}

export default Footer;
